import { render, staticRenderFns } from "./TemplateInquiryDetail.vue?vue&type=template&id=2a65d204&scoped=true"
import script from "./TemplateInquiryDetail.vue?vue&type=script&lang=js"
export * from "./TemplateInquiryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65d204",
  null
  
)

export default component.exports